module.exports = __webpack_public_path__ + "static/media/add-welder.4ba4b18f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/add-welder.jpg
// module id = 1923
// module chunks = 0